import { CardProps, Typography } from '@material-ui/core';
import { CardX } from 'framework/components/cards/CardX';
import { ICompany } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { CompanyDetailsContent } from './CompanyDetailsContent';

interface IProps extends CardProps {
	item: ICompany;
	reload: VoidFunction;
}

export const CompanyDetailsCard = ({ item, reload, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<CardX {...rest}>
			<Typography
				component='div'
				style={{ fontSize: '16px', fontWeight: 500, marginBottom: 16 }}>
				{`${strings.detailsOfVatCustomer}: ${item.name}`}
			</Typography>
			<CompanyDetailsContent
				item={item}
				reload={reload}
			/>
		</CardX>
	);
};
